import axios from "axios";

// Falls back to "" (relative) so the CRA dev proxy can forward /api → backend.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

// Short random id per request so the backend's request-id middleware sees
// something meaningful when correlating cross-tier logs.
function shortId() {
  return Math.random().toString(36).slice(2, 10) + Math.random().toString(36).slice(2, 6);
}

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("wa_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  cfg.headers["X-Request-ID"] = cfg.headers["X-Request-ID"] || shortId();
  return cfg;
});

// Response interceptor: pass 2xx through unchanged; log 5xx and network
// errors to console with the request id so ops can grep both tiers. We
// deliberately do NOT toast on error here so per-page components keep
// full control of user-facing error UX; this is diagnostics only.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const cfg = err?.config || {};
    const rid = cfg.headers?.["X-Request-ID"] || "(no-id)";
    const method = (cfg.method || "GET").toUpperCase();
    const url = cfg.url || "";
    const status = err?.response?.status;
    if (typeof window !== "undefined" && window.console) {
      if (!err.response) {
        window.console.warn(`[api] ${method} ${url} network error id=${rid}: ${err.message}`);
      } else if (status >= 500) {
        window.console.error(`[api] ${method} ${url} ${status} id=${rid}`, err.response.data);
      }
    }
    return Promise.reject(err);
  }
);

export default api;
